module.exports = __webpack_public_path__ + "media/dashboard/assets/images/no-chat-dark-47cacd0972a4cba7686816851ffeeeb6.svg";